module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMyIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDIzIDEwIj4KICAgIDxwYXRoIGZpbGw9IiNDNUNGRDciIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE1LjYyIDB2My4xNEgwdjMuMjJoMTUuNjJWOS41bDcuMzg0LTQuNzV6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-rejected.svg
// module id = /1nX
// module chunks = 1